/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import $ from 'jquery';
import {load} from '@shopify/theme-sections';
import Variants from '@shopify/theme-variants';
import {formatMoney} from '@shopify/theme-currency';
import {register} from '@shopify/theme-sections';
import Swiper, { Navigation,  Thumbs, A11y, Keyboard, Zoom, Pagination } from 'swiper';
import "./store-geolocation";

// // Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/zoom';

const selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productImageWrapper: '[data-product-image-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-page]',
    productOptionMessagesJson: '[data-product-option-messages]',
    productPrice: '[data-product-price]',
    productThumbnailsSlider: 'carousel--product-thumbnails',
    productFeatureSlider: 'carousel--featured-product',
    productThumbs: '[data-product-single-thumbnail]',
    radioOptionSelector: '[data-radio-option-selector]',
    singleOptionSelector: '[data-single-option-selector]',
    productMediaWrapper: '[data-product-single-media-wrapper]',
    productMediaTypeVideo: '[data-product-media-type-video]',
    productMediaTypeModel: '[data-product-media-type-model]',
    variantOptionLabels: '.form__element .swatch__option label',
    colorOptionLabels: '.color-swatches .swatch__option',
    quantity: '#Quantity',
    productSwiperFeature: null,
};

const cssClasses = {
    activeThumbnail: 'active-thumbnail',
    hide: 'hide',
};

const keyboardKeys = {
    ENTER: 13,
};

var size_selected = false;
var productFeatureSwiper;

function toggleInnerFocus(slider) {
    let focusableElements = ['iframe', 'input', 'select', 'option', 'textarea', 'button', 'video', 'label', 'a', '.plyr', 'model-viewer'];
    $(focusableElements).each(function(index, el) {
        $(slider.slides).each(function(index, slide) {
            if (index === slider.activeIndex) {
                if (el === '.plyr') {
                    $(slide).find(el)
                    .attr('tabindex', "0");
                } else {
                    $(slide).find(el)
                    .removeAttr('tabindex');
                }
            } else {
                $(slide)
                .find(el)
                .attr('tabindex', '-1');
            }
        })
    })
}

$(document).ready(function(){
    var currentLang = "en";

    if(typeof Weglot != 'undefined') { // Check if Weglot exists or not. If yes, get the current selected language
        currentLang = Weglot.getCurrentLang();
    }

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */

    register('product', {
        onLoad() {
            this.$container = $(this.container);
            this.namespace = `.${this.id}`;
            var self = this;

            // Stop parsing if we don't have the product json script tag when loading
            // section in the Theme Editor
            if (!$(selectors.productJson, this.$container).html()) {
                return;
            }

            this.productSingleObject = JSON.parse(
                $(selectors.productJson, this.$container).html(),
            );

            const options = {
                $container: this.$container,
                enableHistoryState: this.$container.data('enable-history-state') || false,
                radioOptionSelector: this.radioOptionSelector,
                singleOptionSelector: selectors.singleOptionSelector,
                originalSelectorId: selectors.originalSelectorId,
                product: this.productSingleObject,
            };

            this.settings = {};
            this.variants = new Variants(options);
            this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

            this.$container.on(
                `variantChange${this.namespace}`,
                this.updatePDPInformation.bind(this)
            );
            this.$container.on(
                `variantChange${this.namespace}`,
                this.updateProductPrices.bind(this),
            );

            $('.form__increment').on('click', function() {
                self.$container.trigger({
                    type: 'variantPriceChange',
                    variant: self.variants.currentVariant
                });
            });


            var notificationCallback = function(data) {

                if (currentLang == "fr") {
                    $('#modal_bis .modal__content').html("<div class='bis-success-message'></div>");
                    Weglot.translate(
                        {
                        'words':[ { "t":5,"w": "Thank you for your interest" } ],
                        'languageTo':'fr'
                        }
                        , function(data) {
                            $('#modal_bis .modal__content .bis-success-message').append("<h3>"+ data[0] +"</h3>");

                            Weglot.translate(
                                {
                                    'words':[ { "t":13,"w": "You'll hear from us as soon as the item is back in stock!" } ],
                                    'languageTo':'fr'
                                }
                                , function(data) {
                                    $('#modal_bis .modal__content .bis-success-message').append("<p>"+ data[0] +"</p>");
                                }
                            );
                        }
                    );
                } else {
                    $('#modal_bis .modal__content').html('<div class="bis-success-message"><h3>Thank you for your interest</h3><p>You\'ll hear from us as soon as the item is back in stock!</p></div>');
                }
            }

            $("#notify_button").on("click", function(e){
                e.preventDefault();
                var email = $('#notify_email').val(),
                phone = $('#notify_phone').val(),
                productId = $('#notify_product').val(),
                variantId = $('#notify_variant').val(),
                marketing = $("#customer_accepts_marketing").is(":checked");
                if (phone != '') {
                    phone = phone.replace(/\D/g,'');
                    phone = '+1' + phone;
                    BIS.create(email, variantId, productId, { accepts_marketing: marketing, phone_number: phone }).then(notificationCallback);
                } else if (email != "") {
                    BIS.create(email, variantId, productId, { accepts_marketing: marketing }).then(notificationCallback);
                }
            })

            let last_chance_options = [];
            $( ".swatch__option.last_chance" ).each(function() {
                last_chance_options.push($( this ).clone())
            });
            $(window).on('load resize', function () {
                if ( $(".product__form--old").length ) {

                    if (window.matchMedia('(min-width: 1025px)').matches) {
                        $( ".color-swatches__container--default .swatch__option.last_chance" ).each(function() {
                            $( this ).hide();
                        });

                        $.each(last_chance_options, function(index, value){
                            value.appendTo(".color-swatches__container--last_chance");
                        });

                        if(!$('.color__name--last_chance').is(':empty')) {
                            $(".color__name").text("");
                            $(".color__label-wrapper").text("");
                        }

                        if($('.color-swatches__container--default').find('.swatch__option').length < 1) {
                            $(".color__container--last_chance").addClass("self-last-chance");
                            $("[class='color__container']").hide();
                        }

                    } else {
                        if ( $(".swatch__option.last_chance").length ) {

                            $( ".color-swatches__container--default .swatch__option.last_chance" ).each(function() {
                                $( this ).show();
                            });
                        }

                        $("[class='color__container']").show();
                    }
                }
            });

            $(window).on('load', function () {
                if ( $(".product__form--new").length ) {
                    $( ".swatch__option.last_chance" ).each(function() {
                        $( this ).appendTo(".color-swatches__container--last_chance");
                    });

                    if(!$('.color__name--last_chance').is(':empty')) {
                        $(".color__name").text("");
                        $(".color__label-wrapper").text("");
                    }

                    if($('.color-swatches__container--default').find('.swatch__option').length < 1) {
                        $(".color__container--last_chance").addClass("self-last-chance");
                        $("[class='color__container']").hide();
                    }
                }
            });

            $(selectors.colorOptionLabels).on('click', function() {
                let $this = $(this);
                $('.product__free-text').empty();

                if (!$this.hasClass('selected')) {
                    const selectedColorSwatch = $(this).attr('data-swatch');
                    $(selectors.colorOptionLabels+".selected").removeClass('selected');
                    $(this).addClass('selected');

                    var productJson = JSON.parse($('#ProductJson-' + $(this).attr('data-product-handle')).html()),
                        productData = productJson,
                        bisHidden = productData.tags.includes('bis-hidden'),
                        modelInfo = $(this).attr('data-model-info');

                    $('.product__free-text').html(modelInfo);

                    $('#notify_product').val(productData.id);
                    $(selectors.originalSelectorId).attr('data-product-handle', productData.handle);

                    $('#BIS-Container').addClass("js__isHidden");
                    $(selectors.addToCart).removeClass('js__isHidden');
                    $(selectors.addToCart, this.$container).prop('disabled', false);

                    if (bisHidden) {
                        $(selectors.originalSelectorId).attr('data-bis-hidden', true);
                    } else {
                        $(selectors.originalSelectorId).attr('data-bis-hidden', false);
                    }

                    var paths = window.location.pathname.split('/');
                    paths[ paths.length-1 ] = $(selectors.originalSelectorId).attr('data-product-handle');
                    const productVariantURL = paths.join('/');
                    window.history.replaceState("","", productVariantURL);

                    $('.stock-left__container').removeClass('js__isShown');
                    $('.sticky__option-value').each(function(){
                        $(this).text('-');
                    });
                    $("#productStickyContainer").find('.swatch__option').each(function(){
                        $(this).attr('data-swatch', selectedColorSwatch);
                        $(this).find('.form__option-label').attr("data-swatch", selectedColorSwatch);
                        $(this).find('.form__option-label-visually-hidden').text(selectedColorSwatch);
                    });
                    //Uncomment to disable Find in Store button when out of stock
                    //$('.button--find-in-store').addClass('js__isDisabled');
                    $('.js-find-in-store').attr('data-current-variant', '');
                    $('.find-in-store__container .js-accordion__button--close').trigger('click');
                    
                    // Update Wishlist ID
                    $('status-save-button').attr('product-id', productData.id);

                    if ($( window ).width() < 680 ) { // Scrolling to Product Images after switching color on mobile
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(".product__images").offset().top
                        }, 200);
                    }

                    $(selectors.productJson).html($('#ProductJson-' + $(this).attr('data-product-handle')).html());
                    $('.product__form').attr('data-product-handle', $(this).attr('data-product-handle'));

                    var productOptionsJson = JSON.parse($('#ProductJson-' + $(this).attr('data-product-handle')+'-options').html());
                    var productOptions = productOptionsJson;
                    var variantInventory = JSON.parse($('#ProductJson-' + $(this).attr('data-product-handle')+'-inventory').html());
                    var media = productData.media;
                    var productVariants = productData.variants;
                    var mediaCount = 0;
                    var productImagesSwiperWrapper = '';

                    $('.btn--add-to-cart--quick').addClass('btn--select-size');

                    if (currentLang == "fr") {

                        Weglot.translate(
                            {
                            'words':[ { "t":2,"w": "Add To Cart" } ],
                            'languageTo':'fr'
                            }
                            , function(data) {
                                $(selectors.addToCartText).text(data[0]);
                            }
                        );
                    } else {
                        $(selectors.addToCartText).text('Add To Cart');
                    }

                    for (let i = 0; i < media.length; i++) {
                        productImagesSwiperWrapper += "<div class='swiper-slide' tabindex='0' data-acsb-navigable='true' data-index='"+i+"'>";
                        productImagesSwiperWrapper += "<div id='FeaturedMedia-product--group-"+media[i].id+"wrapper' class='product-single__media-wrapper js' data-product-single-media-wrapper='' data-media-id='product--group-'" + media[i].id + "'>";

                        if (media[i].media_type == 'image') {
                            productImagesSwiperWrapper += "<picture>";
                                productImagesSwiperWrapper += "<img class='responsive-image__image background-image' src='"+media[i].src+"' srcset='"+media[i].src+"&amp;width=180 180w,"+media[i].src+"&amp;width=360 360w,"+media[i].src+"&amp;width=540 540w,"+media[i].src+"&amp;width=680 680w,"+media[i].src+"&amp;width=720 720w,"+media[i].src+"&amp;width=900 900w,"+media[i].src+"&amp;width=1080 1080w,' tabindex='-1' alt='"+media[i].alt+"' decoding='async' loading='lazy'>";
                            productImagesSwiperWrapper += "</picture>";
                            
                            productImagesSwiperWrapper += "<button class='media-zoom-button' data-image-id='FeaturedMedia-product--group-"+media[i].id+"wrapper' tabindex='-1'>";
                                productImagesSwiperWrapper += "<span class='icon svg--baseline'>";
                                    productImagesSwiperWrapper += "<svg class='icon icon__zoom'>";
                                      productImagesSwiperWrapper += "<use xlink:href='#icon-zoom'></use>";
                                    productImagesSwiperWrapper += "</svg'>";
                                productImagesSwiperWrapper += "</span>";
                            productImagesSwiperWrapper += "</button>";
                            
                        } else if (media[i].media_type == 'video') {
                            // Prevents Video from playing if contains sounds.
                            var soundVideo = media[i].alt.includes("video-with-sound");

                            productImagesSwiperWrapper += "<div class='background-media background-media--video'>";
                                productImagesSwiperWrapper += "<div class='video-block video-block--html5 video-block--is-paused'>";
                                    productImagesSwiperWrapper += "<div class='video-block__controls'>";
                                        productImagesSwiperWrapper += "<div class='video-block__controls-static'>";
                                            productImagesSwiperWrapper += "<span class='icon video-block__control video-block__control--play' tabindex='0'><svg class='icon icon__play--white'><use xlink:href='#icon-play--white'></use></svg></span>";
                                            productImagesSwiperWrapper += "<span class='icon video-block__control video-block__control--pause' tabindex='0'><svg class='icon icon__pause--banner'><use xlink:href='#icon-pause--banner'></use></svg></span>";
                                        productImagesSwiperWrapper += "</div>";
                                    productImagesSwiperWrapper += "</div>";
                                    if (soundVideo) {
                                        productImagesSwiperWrapper += "<video class='video-block__video' preload='preload' playsinline=''>";
                                    } else {
                                        productImagesSwiperWrapper += "<video class='video-block__video' preload='preload' muted='muted' loop='loop' playsinline='' autoplay>";
                                    }
                                        for(var j = media[i].sources.length-1; j >= 0; j--) {
                                            productImagesSwiperWrapper += '<source src="' + media[i].sources[j].url + '" type="' + media[i].sources[j].mime_type  + '">'
                                        }
                                    productImagesSwiperWrapper += "</video>";
                                productImagesSwiperWrapper += "</div>";
                            productImagesSwiperWrapper += "</div>";

                        }

                        productImagesSwiperWrapper += "</div>";
                        productImagesSwiperWrapper += "</div>";

                    }

                    var productVariantOptions = "";
                    for (let i = 0; i < productVariants.length; i++) {
                        var variantDisabled = (productVariants[i].available == true) ? "" : "disabled='disabled'";
                        productVariantOptions += "<option "+ variantDisabled +" value='"+productVariants[i].id+"' data-option-title='"+productVariants[i].title+"' data-inventory-quantity='"+variantInventory[i].inventory_quantity+"'>"+productVariants[i].title+"</option>";
                        $(selectors.originalSelectorId).html(productVariantOptions);
                    }

                    // Re-populate the Product Options on switching color
                    for (let i = 0; i < productOptions.length; i++) {
                        var optionIndex = i + 1,
                            optionSelector = $("#optionSelector" + optionIndex),
                            optionSelectorType = optionSelector.attr("data-type"),
                            optionSelectedVal = optionSelector.find("input[type='radio']:checked").val(),
                            productOptionValues = productOptions[i].values,
                            swatchOptions = "";

                        if (optionSelectorType == "radio") {
                            var optionFormElement = optionSelector.find('.form__element');

                            for (let j = 0; j < productOptionValues.length; j++) {
                                var productOptionIndex = j+1;

                                if (optionSelectedVal == productOptionValues[j]) {
                                    swatchOptions += "<div class='swatch__option selected' data-swatch='"+productOptionValues[j]+"'>";
                                        swatchOptions += "<input checked type='radio' data-single-option-selector='' id='"+productOptions[i].name+"-"+productOptionIndex+"' value='"+productOptionValues[j]+"' name='"+productOptions[i].name+"' data-index='option"+optionIndex+"' data-type='radio' class='sr-only'>";
                                        swatchOptions += "<label for='"+productOptions[i].name+"-"+productOptionIndex+"' class='form__option-label'><span class='form__option-label-inner'></span><span class='form__option-label-visually-hidden'>"+productOptionValues[j]+"</span></label>";
                                    swatchOptions += "</div>";
                                } else {
                                    swatchOptions += "<div class='swatch__option' data-swatch='"+productOptionValues[j]+"'>";
                                        swatchOptions += "<input type='radio' data-single-option-selector='' id='"+productOptions[i].name+"-"+productOptionIndex+"' value='"+productOptionValues[j]+"' name='"+productOptions[i].name+"' data-index='option"+optionIndex+"' data-type='radio' class='sr-only'>";
                                        swatchOptions += "<label for='"+productOptions[i].name+"-"+productOptionIndex+"' class='form__option-label'><span class='form__option-label-inner'></span><span class='form__option-label-visually-hidden'>"+productOptionValues[j]+"</span></label>";
                                    swatchOptions += "</div>";
                                }
                            }

                            optionFormElement.html(swatchOptions);
                        }
                    }

                    // Re-initialize the product thumbnails swiper
                    $('.product__feature-image .swiper-wrapper').html(productImagesSwiperWrapper);

                    //Clone Product media into Zoom modal
                    let modal = $('.modal--product-zoom');
                    
                    const modalTitle = modal.find('.product__title');
                    modalTitle.text(productData.title);
                    
                    // Get Swiper Slides Content
                    const swipperContent = $('.product__feature-image.carousel--featured-product.swiper .swiper-wrapper').children();
                    let zoomModalContent = "";
                    
                    // Filter Video Slides
                    swipperContent.each(function () {
                        const slide = this;
                        const slideVideo = slide.querySelector('.video-block');
                        
                        if (!slideVideo) zoomModalContent += slide.outerHTML;
                    });
                    
                    // Clone Product media into modal
                    $('.modal__content_media_container').html(zoomModalContent);

                    //Zoom Product Modal Open and Close Functions
                    $('.media-zoom-button, .product-single__media-wrapper picture img').on( "click", (e) => {
                        const productImage = e.target;

                        if ($(window).width() < 1024) {
                            return;
                        }
                        const imageID = productImage.closest('.product-single__media-wrapper').id;

                        modal.addClass('modal--open');
                        $('body').addClass('noscroll');
                        $('.shopify-section--header').addClass('sendback');

                        //Gives buffer time for modal to open and be able to focus image
                        setTimeout(function() {
                            document.querySelector('.modal__content_media_container #'+imageID).scrollIntoView({block: "start"});
                        },150);
                        $(window).trigger('open.modal', modal);
                    });

                    $('.close-zoom, .icon-close-zoom').on( "click", () => {
                        if ($(window).width() < 1024) {
                            return;
                        }
                        modal.removeClass('modal--open');

                        $('body').removeClass('noscroll');
                        $('.shopify-section--header').removeClass('sendback');
                        $(window).trigger('close.modal', modal);
                    });

                    self.productSingleObject = JSON.parse(
                        $(selectors.productJson, this.$container).html(),
                    );

                    const options = {
                        $container: self.$container,
                        enableHistoryState: self.$container.data('enable-history-state') || false,
                        radioOptionSelector: self.radioOptionSelector,
                        singleOptionSelector: selectors.singleOptionSelector,
                        originalSelectorId: selectors.originalSelectorId,
                        product: self.productSingleObject,
                    };

                    // Re-bind updatePDPInformation and updateProductPrices with new selected variant
                    self.settings = {};
                    self.variants = new Variants(options);
        
                    self.optionMessages = {};

                    self.$container.on(
                        `variantChange${self.namespace}`,
                        self.updatePDPInformation.bind(self)
                    );
                    self.$container.on(
                        `variantChange${self.namespace}`,
                        self.updateProductPrices.bind(self),
                    );

                    // Keep the current selected options (Size, Waist, Length, etc...) on switching color
                    $("select[name='id'] option").each(function(){

                        if (this.value == self.variants.currentVariant.id) {
                              $("select[name='id']").val(this.value).trigger("change");
                        }
                    });

                    self.$container.trigger({
                        type: 'variantChange',
                        variant: self.variants.currentVariant
                    });

                    // Updates data in in Back in Stock Modal
                    if (self.variants.currentVariant) {
                        $("#modal_bis .modal__info .notify__variant-title").html(self.variants.currentVariant.name);
                    } else {
                        $("#modal_bis .modal__info .notify__variant-title").html(productData.title);
                    }
                    $("#modal_bis .modal__media img").attr("src", media[0].src);

                    self.initProductVideos();
                    self.initProductCarousel(true);
                }
            });

            $('.btn--add-to-cart--quick').on('click', function() {
                let $this = $(this);
                if( $this.hasClass('btn--select-size') ) {
                    var $atc_error_messge = $this.parents('.product__form').children('.add-to-cart__error-wrapper');
                    if( $atc_error_messge.length ) {
                        $atc_error_messge.addClass("error-show");
                    }
                    return false;
                }
            });

            $(selectors.quantity).on('change', function() {
                self.$container.trigger({
                    type: 'variantPriceChange',
                    variant: self.variants.currentVariant
                });
            });

            if (this.$featuredImage.length > 0) {
                this.$container.on(
                    `variantImageChange${this.namespace}`,
                    this.updateImages.bind(this),
                );
            }

            //Updates Back in Stock Closing icons
            $(window).on('load resize',  () => {
                const BIS_modal_close_icon = $("#modal_bis .modal__close-button svg use");
                if (window.matchMedia('(min-width: 1025px)').matches) {
                    BIS_modal_close_icon.attr("xlink:href","#icon-close--cart-confirmation");
                } else {
                    BIS_modal_close_icon.attr("xlink:href","#icon-chevron--down-light");
                }
            });

            this.initProductCarousel();
            this.updateImages({
                variant: this.variants.currentVariant
            });
            this.loadOptionMessages();
            this.initVariantTitles();
            // this.initVariantHoverWatch();
            this.initColorHoverWatch();
            this.updateVariantAvailability(this.$container[0], this.variants.currentVariant);
            this.initStickyCart();
           // this.disableVariants(target, availableValues);
        },

        initProductVideos: function() {
            var html5Video = {
                init: function() {
                    this.bindEventListeners();
                },

                play: function(event) {
                    event.data.player.play();
                },

                pause: function(event) {
                    event.data.player.pause();
                },

                bindEventListeners: function() {
                    // Bind Listeners for Custom Controls
                    $('.video-block--html5').each(function() {
                        $(this).on('play.video-block',   { player: html5Video.getPlayer(this) }, html5Video.play);
                        $(this).on('pause.video-block',  { player: html5Video.getPlayer(this) }, html5Video.pause);
                    });

                    // Bind Listeners for HTML5 Video Events
                    $('.video-block--html5 .video-block__video').each(function() {
                        this.onplay = function() {
                            $(this).parents('.video-block').trigger('onplay.video-block');
                        };

                        this.onpause = function() {
                            $(this).parents('.video-block').trigger('onpause.video-block');
                        };

                        this.onended = function() {
                            $(this).parents('.video-block').trigger('onended.video-block');
                        };
                    });
                },

                getPlayer: function(element) {
                    return $(element).find('.video-block__video').get(0);
                }
            };

            // Initialize HTML5 Video
            html5Video.init();

            var CONTROLS_PLAY   = '.video-block__control--play';
            var CONTROLS_PAUSE  = '.video-block__control--pause';

            // Prepare Control Interactions
            var videoBlockControls = {
                play: function(videoBlock) {
                    $(videoBlock)
                        .removeClass('video-block--is-postered') // Remove the poster (if present)
                        .removeClass('video-block--is-paused')   // Indicate video is playing (i.e. not paused)
                    ;
                },
                pause: function(videoBlock) {
                    $(videoBlock)
                        .addClass('video-block--is-paused')
                        .addClass('video-block--is-postered')                                   // Indicate video is paused
                    ;
                }
            };
            $('.video-block').each(function() {

                // Bind Listeners for Custom Controls
                // -------------------------------------------------------------------
                $(this).on('onplay.video-block', function() {
                    videoBlockControls.play(this);
                });

                // Bind Play button
                $(this).find(CONTROLS_PLAY).on('click', function() {
                    videoBlockControls.play($(this).parents('.video-block')); // Provide immediate feedback (since video might need to queue before callback fires)

                    $(this).parents('.video-block').trigger('play.video-block');
                });

                $(this).find(CONTROLS_PAUSE).on('click', function() {
                    videoBlockControls.pause($(this).parents('.video-block')); // Provide immediate feedback (since video might need to queue before callback fires)

                    $(this).parents('.video-block').trigger('pause.video-block');
                });

                // Play Video on keypress
                $(this).find(CONTROLS_PLAY).on('keypress', function(e) {

                    if (e.key == "Enter") {
                        e.preventDefault();

                        videoBlockControls.play($(this).parents('.video-block')); // Provide immediate feedback (since video might need to queue before callback fires)
                        $(this).parents('.video-block').trigger('play.video-block');

                        $(this).siblings(CONTROLS_PAUSE).focus();
                    }
                });

                // Pause Video on keypress
                $(this).find(CONTROLS_PAUSE).on('keypress', function(e) {

                    if (e.key == "Enter") {
                        e.preventDefault();

                        videoBlockControls.pause($(this).parents('.video-block')); // Provide immediate feedback (since video might need to queue before callback fires)
                        $(this).parents('.video-block').trigger('pause.video-block');

                        $(this).siblings(CONTROLS_PLAY).focus();
                    }
                });
            });
        },

        initProductCarousel: function(reInit = false) {
            let self = this,
                productSwiperInit = false,
                desktop = window.matchMedia('(min-width: 1025px)');

            // -------------------------------------
            // Carousel Products
            // -------------------------------------
            function productSwiper(self) {

                if(desktop.matches) {
                    if ( productFeatureSwiper !== undefined ){
                        productFeatureSwiper.destroy();
                    }
                    productSwiperInit = false;
                } else {
                    if(!productSwiperInit) {
                        productSwiperInit = true;

                        if(reInit == true && productFeatureSwiper !== undefined) {
                            productFeatureSwiper.destroy();
                        }

                        productFeatureSwiper = new Swiper('.'+selectors.productFeatureSlider+'', {
                            // Optional parameters
                            modules: [Navigation, Pagination, Thumbs, A11y, Keyboard],
                            spaceBetween: 1,
                            slidesPerView: 1,
                            pagination: {
                                el: ".swiper-pagination--product__feature-image"
                            },
                        });

                        productFeatureSwiper.on('slideChange ', function () {
                            // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
                              var previousSlideIndex = productFeatureSwiper.previousIndex,
                                  currentSlideIndex = productFeatureSwiper.activeIndex;

                              // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
                              var currentMedia = $('.product__feature-image .swiper-slide[data-index="'+currentSlideIndex+'"] .product-single__media-wrapper'),
                                  previousMedia = $('.product__feature-image .swiper-slide[data-index="'+previousSlideIndex+'"] .product-single__media-wrapper');

                              previousMedia.trigger("mediaHidden");
                              currentMedia.trigger("mediaVisible");
                                toggleInnerFocus(this);
                        });

                        selectors.productSwiperFeature = productFeatureSwiper;
                    }
                }
            }

            productSwiper();
            $(window).on('resize', function(){
                productSwiper();
            })
        },


        initVariantTitles() {
            this.changeVariantTitles(this.variants.currentVariant);
        },
        updateSelectedVariants(target, valuesToEnable) {
            // Loop through all the Option Selectors and check which one is a swatch selector
            var optionSelector1 = $(target).find('[data-index="option1"]');
            var optionSelector2 = $(target).find('[data-index="option2"]');
            var optionSelector3 = $(target).find('[data-index="option3"]');
            var is_swatch_selector1 = false;
            var is_swatch_selector2 = false;
            var is_swatch_selector3 = false;

            if (optionSelector1.length && optionSelector1.attr('type') == 'radio') {
                is_swatch_selector1 = true;
            }

            if (optionSelector2.length && optionSelector2.attr('type') == 'radio') {
                is_swatch_selector2 = true;
            }

            if (optionSelector3.length && optionSelector3.attr('type') == 'radio') {
                is_swatch_selector3 = true;
            }

            var $atc_error_messge = $(selectors.addToCart).parents('.product__form').children('.add-to-cart__error-wrapper');
            var $atc_error_option_name = $('.add-to-cart__error-text .error__option-name');

            // If there are 3 option selectors
            if (optionSelector3.length) {
                // if all 3 options are selected
                if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                    (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown") &&
                    (optionSelector3.is(':checked') || optionSelector3.attr('data-type') == "dropdown")) {

                    if( $atc_error_messge.length ) {
                        $atc_error_messge.removeClass("error-show");
                    }
                    $(selectors.addToCart).removeClass('btn--select-size');

                    // if only 1 and 2 are selected
                }  else if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                        (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown") &&
                        (! optionSelector3.is(':checked') || optionSelector3.attr('data-type') != "dropdown")) {
                        $atc_error_option_name.text( optionSelector3.attr('name') )

                        // if only 1 and 3 are selected
                }else if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                        (!optionSelector2.is(':checked') || optionSelector2.attr('data-type') != "dropdown") &&
                        (optionSelector3.is(':checked') || optionSelector3.attr('data-type') == "dropdown")) {
                        $atc_error_option_name.text( optionSelector2.attr('name') )
                }else {
                    return true;
                }
            } else if (optionSelector2.length) {
                // if all 2 options are selected
                if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                    (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown")) {

                    if( $atc_error_messge.length ) {
                        $atc_error_messge.removeClass("error-show");
                    }
                    $(selectors.addToCart).removeClass('btn--select-size');

                } else {
                    return true;
                }
            }
        },
        disableVariants(target, valuesToEnable) {

            // Loop through all the Option Selectors and check which one is a swatch selector
            var optionSelector1 = $(target).find('[data-index="option1"]');
            var optionSelector2 = $(target).find('[data-index="option2"]');
            var optionSelector3 = $(target).find('[data-index="option3"]');
            var is_swatch_selector1 = false;
            var is_swatch_selector2 = false;
            var is_swatch_selector3 = false;

            if (optionSelector1.length && optionSelector1.attr('type') == 'radio') {
                is_swatch_selector1 = true;
            }

            if (optionSelector2.length && optionSelector2.attr('type') == 'radio') {
                is_swatch_selector2 = true;
            }

            if (optionSelector3.length && optionSelector3.attr('type') == 'radio') {
                is_swatch_selector3 = true;
            }

            var option1       = $(target).find('input[data-index="option1"]');
            var option1_count = option1.length;
            var option2       = $(target).find('input[data-index="option2"]');
            var option2_count = option2.length;
            var option3       = $(target).find('input[data-index="option3"]');
            var option3_count = option3.length;

            // If there are 3 option selectors
            if (optionSelector3.length) {
                // If the third option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1 and 2.
                if (is_swatch_selector3 == true) {

                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                    })

                    if( option2_count == 1 && option3_count == 1 ) {
                        var input2 = option2;
                        var input3 = option3;
                        $(input2).attr('checked', true);
                        if (!valuesToEnable.option2.includes(input2.value)) {
                            $(input2.nextElementSibling).addClass('swatch--disabled');
                        }
                        $(input3).attr('checked', true);
                        if (!valuesToEnable.option2.includes(input3.value)) {
                            $(input3.nextElementSibling).addClass('swatch--disabled');
                        }
                        this.updateSelectedVariants(target, valuesToEnable);
                    } else {
                        if( option2_count == 1 ) {
                            var input = option2;
                            $(input).attr('checked', true);
                            if (!valuesToEnable.option2.includes(input.value)) {
                                $(input.nextElementSibling).addClass('swatch--disabled');
                            }
                            this.updateSelectedVariants(target, valuesToEnable);
                        } else{
                            option2.each(function() {
                                var input = $(this)[0];
                                $(input.nextElementSibling).removeClass('swatch--disabled');
                                if (!valuesToEnable.option2.includes(input.value)) {
                                    $(input.nextElementSibling).addClass('swatch--disabled');
                                }
                            });
                        }

                        if( option3_count == 1 ) {
                            var input = option3;
                            $(input).attr('checked', true);
                            if (!valuesToEnable.option3.includes(input.value)) {
                                $(input.nextElementSibling).addClass('swatch--disabled');
                            }
                            this.updateSelectedVariants(target, valuesToEnable);
                        } else{
                            option3.each(function() {
                                var input = $(this)[0];
                                $(input.nextElementSibling).removeClass('swatch--disabled');
                                if (!valuesToEnable.option3.includes(input.value)) {
                                    $(input.nextElementSibling).addClass('swatch--disabled');
                                }
                            });
                        }
                    }

                // If the second option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1 and 3.
                } else if (is_swatch_selector2 == true) {
                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                    });

                    if( option2_count == 1 ) {
                        var input = option2;
                        $(input).attr('checked', true);
                        if (!valuesToEnable.option2.includes(input.value)) {
                            $(input.nextElementSibling).addClass('swatch--disabled');
                        }
                        this.updateSelectedVariants(target, valuesToEnable);
                    } else{
                        option2.each(function() {
                            var input = $(this)[0];
                            $(input.nextElementSibling).removeClass('swatch--disabled');
                            if (!valuesToEnable.option2.includes(input.value)) {
                                $(input.nextElementSibling).addClass('swatch--disabled');
                            }
                        });
                    }

                // If the first option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 2 and 3.
                } else if (is_swatch_selector1 == true) {

                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                        if (!valuesToEnable.option1.includes(input.value)) {
                            $(input.nextElementSibling).addClass('swatch--disabled');
                        }
                    })
                }

            // If there are 2 option selectors
            } else if (optionSelector2.length) {

                // If the second option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1.
                if (is_swatch_selector2 == true) {
                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                    });

                    if( option2_count == 1 ) {
                        var input = option2[0];
                        $(input).attr('checked', true);
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                        if (!valuesToEnable.option2.includes(input.value)) {
                            $(input.nextElementSibling).addClass('swatch--disabled');
                        }
                        this.updateSelectedVariants(target, valuesToEnable);
                    } else{
                        option2.each(function() {
                            var input = $(this)[0];
                            $(input.nextElementSibling).removeClass('swatch--disabled');
                            if (!valuesToEnable.option2.includes(input.value)) {
                                $(input.nextElementSibling).addClass('swatch--disabled');
                            }
                        });
                    }

                // If the first option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 2.
                } else if (is_swatch_selector1 == true) {
                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                        if (!valuesToEnable.option1.includes(input.value)) {
                            $(input.nextElementSibling).addClass('swatch--disabled');
                        }
                    })
                }

            // If there is only 1 option selector
            } else {
                if (is_swatch_selector1 == true) {
                    option1.each(function() {
                        var input = $(this)[0];
                        $(input.nextElementSibling).removeClass('swatch--disabled');
                        if (!valuesToEnable.option1.includes(input.value)) {
                            $(input.nextElementSibling).addClass('swatch--disabled');
                        }
                    });
                }
            }
        },
        updateVariantAvailability(target, variant) {

            // Loop through all the Option Selectors and check which one is a swatch selector
            var optionSelector1 = $(target).find('[data-index="option1"]');
            var optionSelector2 = $(target).find('[data-index="option2"]');
            var optionSelector3 = $(target).find('[data-index="option3"]');
            var is_swatch_selector1 = false;
            var is_swatch_selector2 = false;
            var is_swatch_selector3 = false;

            if (optionSelector1.length && optionSelector1.attr('type') == 'radio') {
                is_swatch_selector1 = true;
            }

            if (optionSelector2.length && optionSelector2.attr('type') == 'radio') {
                is_swatch_selector2 = true;
            }

            if (optionSelector3.length && optionSelector3.attr('type') == 'radio') {
                is_swatch_selector3 = true;
            }

            var availableValues = {
                option1: [],
                option2: [],
                option3: []
            }

            var variants = this.variants.product.variants;
            var currentSelectedOptions = this.variants._getCurrentOptions();


            // Combine all available variants
            var availableVariants = variants.filter(function(el) {
                if (!el.available) {
                    return false;
                }
                var $atc_error_messge = $(selectors.addToCart).parents('.product__form').children('.add-to-cart__error-wrapper');
                var $atc_error_option_name = $('.add-to-cart__error-text .error__option-name');

                // If there are 3 option selectors
                if (optionSelector3.length) {

                    // if all 3 options are selected
                    if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                        (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown") &&
                        (optionSelector3.is(':checked') || optionSelector3.attr('data-type') == "dropdown")) {

                        if( $atc_error_messge.length ) {
                            $atc_error_messge.removeClass("error-show");
                        }
                        $(selectors.addToCart).removeClass('btn--select-size');

                        var currentVariant = {
                            option1: currentSelectedOptions[0].value,
                            option2: currentSelectedOptions[1].value,
                            option3: currentSelectedOptions[2].value
                        };

                        // If the third option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1 and 2.
                        if (is_swatch_selector3 == true) {

                            // Option 3 based on selected Option 1 and 2
                            if ((currentVariant.option1 === el.option1 || !el.option1) &&
                                (currentVariant.option2 === el.option2 || !el.option2)) {
                                return true;
                            }

                        // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1 and 3.
                        } else if (is_swatch_selector2 == true) {

                            if ((currentVariant.option1 === el.option1 || !el.option1) && (currentVariant.option3 === el.option3 || !el.option3)) {
                                return true;
                            }

                        // If the first option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 2 and 3.
                        } else if (is_swatch_selector1 == true) {

                            if ((currentVariant.option2 === el.option2 || !el.option2) && (currentVariant.option3 === el.option3 || !el.option3)) {
                                return true;
                            }
                        }
                        // if only 1 options is selected
                    } else if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                              (! optionSelector2.is(':checked') || optionSelector2.attr('data-type') != "dropdown") &&
                              (! optionSelector3.is(':checked') || optionSelector3.attr('data-type') != "dropdown")) {
                            $atc_error_option_name.text( optionSelector2.attr('name') )

                            var currentVariant = {
                                option1: currentSelectedOptions[0].value
                            };

                            // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1.
                            if (is_swatch_selector2 == true) {

                                // Option 3 based on selected Option 1
                                if ((currentVariant.option1 === el.option1 || !el.option1)) {
                                    return true;
                                }

                            // If the third option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1.
                            }  else if (is_swatch_selector3 == true) {

                                if (currentVariant.option1 === el.option1 || !el.option1) {
                                    return true;
                                }
                            }

                        // if only 2 options are selected
                    }  else if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                                (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown") &&
                                (! optionSelector3.is(':checked') || optionSelector3.attr('data-type') != "dropdown")) {
                            $atc_error_option_name.text( optionSelector3.attr('name') )

                            var currentVariant = {
                                option1: currentSelectedOptions[0].value,
                                option2: currentSelectedOptions[1].value
                            };

                            // If the third option selector is a swatch selector, get available variants for all options of this selector based on selected options fromSelector 1 and 2.
                            if (is_swatch_selector3 == true) {

                                // Option 3 based on selected Option 1 and 2
                                if ((currentVariant.option1 === el.option1 || !el.option1) &&
                                    (currentVariant.option2 === el.option2 || !el.option2)) {
                                    return true;
                                }
                            }
                    }else {
                        return true;
                    }

                // If there are only 2 option selectors
                } else if (optionSelector2.length) {

                    // if all 2 options are selected
                    if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                        (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown")) {

                        if( $atc_error_messge.length ) {
                            $atc_error_messge.removeClass("error-show");
                        }
                        $(selectors.addToCart).removeClass('btn--select-size');

                        var currentVariant = {
                            option1: currentSelectedOptions[0].value,
                            option2: currentSelectedOptions[1].value
                        };

                        // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1.
                        if (is_swatch_selector2 == true) {

                            if (currentVariant.option1 === el.option1 || !el.option1) {
                                return true;
                            }

                        // If the first option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 2.
                        } else if (is_swatch_selector1 == true) {

                            if( $atc_error_messge.length ) {
                                $atc_error_messge.removeClass("error-show");
                            }
                            $(selectors.addToCart).removeClass('btn--select-size');

                            if (currentVariant.option2 === el.option2 || !el.option2) {
                                return true;
                            }
                        }

                        // if only 1 options are selected
                    } else if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                              (! optionSelector2.is(':checked') || optionSelector2.attr('data-type') != "dropdown")) {
                        $atc_error_option_name.text( optionSelector2.attr('name') )

                        var currentVariant = {
                            option1: currentSelectedOptions[0].value
                        };

                        // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1.
                        if (is_swatch_selector2 == true) {

                            if (currentVariant.option1 === el.option1 || !el.option1) {
                                return true;
                            }
                        }
                    } else {
                        return true;
                    }

                } else if (optionSelector1.length) {
                    if (optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") {
                        if( $atc_error_messge.length ) {
                            $atc_error_messge.removeClass("error-show");
                        }
                        $(selectors.addToCart).removeClass('btn--select-size');
                    }
                        return true;
                }

            });
            availableVariants = Object.assign({}, availableVariants);

            for (var property in availableVariants) {
                if (availableVariants.hasOwnProperty(property)) {
                  var item = availableVariants[property],
                      option1 = item.option1,
                      option2 = item.option2,
                      option3 = item.option3;

                  if (option1) {
                    if (availableValues.option1.indexOf(option1) === -1) {
                        availableValues.option1.push(option1);
                    }
                  }
                  if (option2) {
                    if (availableValues.option2.indexOf(option2) === -1) {
                      availableValues.option2.push(option2);
                    }
                  }
                  if (option3) {
                    if (availableValues.option3.indexOf(option3) === -1) {
                      availableValues.option3.push(option3);
                    }
                  }
                }
            }


            this.disableVariants(target, availableValues);
        },


        slideToSlide(slider, slideIndex, transition) {
            if (transition) {
                slider.slideTo(slideIndex);
            } else {
                slider.slideTo(slideIndex, 0);
            }
        },

        // triggering change image when using with Slider
        swapImage(imageId) {

            let newImageId = imageId;

            // If "imageId" is not defined in the function parameter, find it by the current product image
            if (typeof newImageId === 'undefined') {
                newImageId = $(
                    `${selectors.productImageWrapper}:not('.${cssClasses.hide}')`,
                ).data('image-id');
            }

            const $thumbnail = $(
                `${selectors.productThumbs}[data-thumbnail-id='${newImageId}']`,
            );
            var slideIndex = parseInt($thumbnail.parents('.swiper-slide').attr('data-index'));

            // Swipe JS
            this.slideToSlide(selectors.productSwiperThumbs, slideIndex, false);
            this.slideToSlide(selectors.productSwiperFeature, slideIndex, false);

        },

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState(evt) {
            const variant = evt.variant;
            this.updateVariantAvailability(evt.target, variant);
            let $this = this;

            let optionSelector1 = $(evt.target).find('[data-index="option1"]'),
                optionSelector2 = $(evt.target).find('[data-index="option2"]'),
                optionSelector3 = $(evt.target).find('[data-index="option3"]'),
                flag = false;
            if (optionSelector3.length) {
                if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                    (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown") &&
                    (optionSelector3.is(':checked') || optionSelector3.attr('data-type') == "dropdown")) {
                    flag = true;
                }
            } else if (optionSelector2.length) {
                if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                    (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown")) {
                    flag = true;
                }
            } else if (optionSelector1.length) {
                if (optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") {
                    flag = true;
                }
            }

            if (flag == true) {

                // Show stock left on low threshold
                $(selectors.originalSelectorId).find('option').each(function(){
                    if ($(this).val() == variant.id) {
                        const inventory_quantity = parseInt($(this).attr('data-inventory-quantity'));
                        $('.stock-left__count').text(inventory_quantity);
                        if(0 < inventory_quantity && inventory_quantity < 5) {
                            $('.stock-left__container').addClass('js__isShown');
                        } else {
                            $('.stock-left__container').removeClass('js__isShown');
                        }
                        return false;
                    }
                })

                if (variant) {
                    $(selectors.priceWrapper, this.$container).removeClass(cssClasses.hide);
                    $("#notify_variant").val(variant.id);
                    $("notify_variant-title").text(variant.title);

                    // Update current product url based on selected color variant
                    let paths = window.location.pathname.split('/');
                    paths[ paths.length-1 ] = $(selectors.originalSelectorId).attr('data-product-handle') +"?variant=" + variant.id;
                    const productVariantURL = paths.join('/');
                    window.history.replaceState("","", productVariantURL);
                } else {
                    $(selectors.addToCart, this.$container).prop('disabled', true);
                    $("#notify_variant").val("");

                    if (currentLang == "fr") {

                        Weglot.translate(
                            {
                            'words':[ { "t":1,"w": theme.strings.unavailable } ],
                            'languageTo':'fr'
                            }
                            , function(data) {
                                $(selectors.addToCartText, $this.$container).html(data[0]);
                            }
                        );
                    } else {
                        $(selectors.addToCartText, this.$container).html(
                            theme.strings.unavailable,
                        );
                    }

                    $(selectors.priceWrapper, this.$container).addClass(cssClasses.hide);
                    return;
                }


                $('.js-find-in-store').attr('data-current-variant', variant.id);

                // Populate the current stocks at each available DUER locations
                $('.js-tab--stores__button--desktop.is-open').each(function(){
                    let INVENTORY_API_URL = $('.accordion--find-in-store').attr('data-inventory-url'); // Live store API

                    if (Shopify.shop == "duerdevusd.myshopify.com") {
                        INVENTORY_API_URL = 'https://eorqeg2rvhksi5r.m.pipedream.net/?id='; // Test API
                    }

                    let selected_store = $(this).attr('data-store-id');
                    let current_variant_id = $('.js-find-in-store').attr('data-current-variant');

                    $.get(INVENTORY_API_URL+current_variant_id, function(data, status){

                        var inventoryLevel = data.inventory_levels.find(function (level) {
                            return level.location_id.toString() === selected_store
                        })

                        if (!inventoryLevel) {
                            return;
                        }

                        $('.store__available-stock').text(inventoryLevel.available);
                        // Toggle icons based on current quantity
                        if (inventoryLevel.available > 0) {
                            $('.find-in-store__stock-icon--out-of-stock').addClass('hide');
                            $('.find-in-store__stock-icon--available').removeClass('hide');
                        } else {
                            $('.find-in-store__stock-icon--out-of-stock').removeClass('hide');
                            $('.find-in-store__stock-icon--available').addClass('hide');
                        }
                    })
                })

                if (variant.available) {
                    $("#BIS-Container").addClass('js__isHidden');

                    $(selectors.addToCart).removeClass('js__isHidden');
                    $(selectors.addToCart, this.$container).prop('disabled', false);

                    if (currentLang == "fr") {
                        Weglot.translate(
                            {
                            'words':[ { "t":3,"w": theme.strings.addToCart } ],
                            'languageTo':'fr'
                            }
                            , function(data) {
                                $(selectors.addToCartText, $this.$container).html(data[0]);
                            }
                        );
                    } else {
                        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
                    }

                } else {

                    // Display Back in Stock link when the selected variant is out of stock
                    if ($(selectors.originalSelectorId).attr('data-bis-hidden') == 'true') {
                        $("#BIS-Container").addClass('js__isHidden');
                        $(selectors.addToCart).removeClass('js__isHidden');
                    } else {
                        $("#BIS-Container").removeClass('js__isHidden');
                        $(selectors.addToCart).addClass('js__isHidden');
                        // Updates data in in Back in Stock Modal
                        $("#modal_bis .modal__info .notify__variant-title").html(variant.name);

                    }
                    $(selectors.addToCart, this.$container).prop('disabled', true);
                    $("#modal_bis").find('#notify_variant').val(variant.id);

                    if (currentLang == "fr") {
                        Weglot.translate(
                            {
                            'words':[ { "t":2,"w": theme.strings.soldOut } ],
                            'languageTo':'fr'
                            }
                            , function(data) {
                                $(selectors.addToCartText, $this.$container).html(data[0]);
                            }
                        );
                    } else {
                        $(selectors.addToCartText, this.$container).html(
                            theme.strings.soldOut,
                        );
                    }

                }
            }
        },

        changeVariantTitles(evt) {
          // Clear Option messages on change.
          const optionMessages = document.querySelectorAll('.options__variant-message');
          optionMessages.forEach(message => message.innerText = '');
          
          // Add new content based only on checked option
          $('.swatch__option input[data-single-option-selector]:checked').each(function() {
            var container = $(this).parents('.form__element');
            var subtitle = container.find('.swatch__title .swatch__subtitle');
            subtitle.text($(this).val());

            var optionIndex = $(this).attr("data-index");
            $('.sticky-container__product-option[data-index="'+optionIndex+'"]').find('.sticky__option-value').text($(this).val());
            
            // Renders Custom Text based on product.metafields.iamota.options_messages
            const optionIdentifier  =  $(this).attr('name');
            const optionVariant     =  $(this).val().toString();
            
            const optionMessage     = self.optionMessages?.[optionIdentifier]?.[optionVariant];
            const optionHeader      = container.closest('.product__container').find(`.options__heading--${optionIdentifier}`); 

            if (optionMessage) {
                optionHeader.find('.options__variant-message').text(optionMessage);
            } else {
                optionHeader.find('.options__variant-message').text('');
            }
          })
        },

        changeColorTitles(evt) {
            $('.color-swatches__container .swatch__option.selected').each(function() {
                var container = $(this).parents('.color-swatches');
                var subtitle = container.find('.color__container .color__name');
                var subtitleLastChance = container.find('.color__container .color__name--last_chance');
                var colorLabel = container.find('.color__container .color__label');

                subtitleLastChance.text("");
                subtitle.text($(this).attr('data-swatch'));

                if ($(this).attr('data-color-label')) {
                    if ($(this).attr('data-color-label') == "Last Chance" && window.matchMedia('(min-width: 1025px)').matches) {
                        colorLabel.find('.color__label-wrapper').text("");
                        colorLabel.removeClass('js__isShown');
                    } else {
                        colorLabel.find('.color__label-wrapper').text($(this).attr('data-color-label'));
                        colorLabel.addClass('js__isShown');
                    }
                } else {
                    colorLabel.find('.color__label-wrapper').text("");
                    colorLabel.removeClass('js__isShown');
                }
            })
          },

        tempChangeColorTitle(evt) {
            var target = evt.currentTarget;
            var newLabel = target.innerText;
            var container = $(target).parents('.color-swatches');
            var subtitle = container.find('.color__container .color__name');
            var subtitleLastChance = container.find('.color__container .color__name--last_chance');
            var colorLabel = container.find('.color__container .color__label');

            subtitleLastChance.text("");
            subtitle.text(newLabel);

            if ($(target).attr('data-color-label')) {
                if ($(target).attr('data-color-label') == "Last Chance" && window.matchMedia('(min-width: 1025px)').matches) {
                    colorLabel.find('.color__label-wrapper').text("");
                    colorLabel.removeClass('js__isShown');
                } else {
                    colorLabel.find('.color__label-wrapper').text($(target).attr('data-color-label'));
                    colorLabel.addClass('js__isShown');
                }
            } else {
                colorLabel.find('.color__label-wrapper').text("");
                colorLabel.removeClass('js__isShown');
            }
        },

        tempChangeVariantTitle(evt) {
          var target = evt.currentTarget;
          var newLabel = target.innerText;
          var container = $(target).parents('.form__element');
          var subtitle = container.find('.swatch__title .swatch__subtitle');
          subtitle.text(newLabel);
        },

        initVariantHoverWatch() {
          var changeVariantTitles = this.changeVariantTitles;
          var tempChangeVariantTitle = this.tempChangeVariantTitle;
          $('.swatch__option input[data-single-option-selector] + label.form__option-label').each(function() {
            $(this).on('mouseenter', tempChangeVariantTitle).on('mouseleave', changeVariantTitles);
          });
        },

        initColorHoverWatch() {
            var changeColorTitles = this.changeColorTitles;
            var tempChangeColorTitle = this.tempChangeColorTitle;
            $('.color-swatches__container .swatch__option').each(function() {
              $(this).on('mouseenter', tempChangeColorTitle).on('mouseleave', changeColorTitles);
            });
          },

        updatePDPInformation(evt) {
            this.updateAddToCartState(evt);
            this.changeVariantTitles(evt);
        },

        updateImages(evt) {
            const variant = evt.variant;

            if (typeof variant.featured_media != 'undefined') {

                const imageId = this.id + "-" + variant.featured_media.id;

                this.swapImage(imageId);
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices(evt) {
            const variant = evt.variant;
            const $comparePrice = $(selectors.comparePrice, this.$container);
            const $compareEls = $comparePrice.add(
                selectors.comparePriceText,
                this.$container,
            );

            $(selectors.productPrice, this.$container).html(
                formatMoney(variant.price, theme.moneyFormat),
            );

            $('#addToCartPricing').html(
                formatMoney(variant.price, theme.moneyFormat),
            );

            $('.easy-payment__price').html(
                formatMoney(variant.price/4, theme.moneyFormat),
            )

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(
                    formatMoney(variant.compare_at_price, theme.moneyFormat),
                );
                $compareEls.removeClass(cssClasses.hide);
                $(selectors.productPrice, this.$container).addClass('price__original--sale');
            } else {
                $comparePrice.html('');
                $compareEls.addClass(cssClasses.hide);
                $(selectors.productPrice, this.$container).removeClass('price__original--sale');
            }
        },

        initStickyCart() {
          let options = {
            rootMargin: '100px 0px 0px 0px',
            threshold: [0,0.01,1]
          }

          let target = document.querySelector('#productStickyContainer');

          let observer = new IntersectionObserver(this.showHideStickyCart, options);

          observer.observe(target);

          // Mobile cart button
          $('#addToCartSticky').on('click', function() {
            target.scrollIntoView({ behavior: 'smooth' });
          })

        },

        showHideStickyCart(entries, observer) {
            let entry = entries[0];
            if (entry.intersectionRatio >= 1) {
                entry.target.classList.remove('product__sticky--show');
                $('body').removeClass('product__sticky--show');
            } else if (entry.intersectionRatio <= 0 && entry.boundingClientRect.y <= 0) {
                entry.target.classList.add('product__sticky--show');
                $('body').addClass('product__sticky--show');
                entry.target.classList.remove('product__sticky--hide');
            } else {
                entry.target.classList.add('product__sticky--hide');
            }
        },
        
        loadOptionMessages() {
            const optionMessagesArray = document.querySelector(selectors.productOptionMessagesJson);
            
            if (!optionMessagesArray) return false;
            
            const optionMessagesJson = JSON.parse(optionMessagesArray.innerHTML);
            const optionMessagesObject = {};
            
            optionMessagesJson.forEach((optionEntry) => {
                const optionArray = optionEntry.split("|");

                if (optionArray.length !== 3) return; 
                
                const optionIdentifier  = optionArray[0].replace(/(\r\n|\n|\r)/gm, "").trim();
                const optionVariant     = optionArray[1].toString().trim();
                const optionMessage     = optionArray[2].trim();
                
                if (optionMessagesObject[optionIdentifier] === undefined) {
                    optionMessagesObject[optionIdentifier] = {};
                }
                
                if (optionMessagesObject[optionIdentifier][optionVariant] === undefined) {
                    optionMessagesObject[optionIdentifier][optionVariant] = optionMessage;
                }
            });
            
            self.optionMessages = optionMessagesObject;
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {
            this.$container.off(this.namespace);
        },

    });

    load('product');
})
